import { createBrowserRouter, Navigate } from 'react-router-dom'
import { RequireAuth } from '@/features/auth/RequireAuth'
import { LoginPage } from '@/pages/auth/LoginPage'
import { AcceptInvitePage } from '@/pages/auth/AcceptInvitePage'
import { ResetPasswordPage } from '@/pages/auth/ResetPasswordPage'
import { FacilitiesPage } from '@/pages/FacilitiesPage'
import { AdminOrganizationsPage } from '@/pages/admin/AdminOrganizationsPage'
import { AdminFacilitiesPage } from '@/pages/admin/AdminFacilitiesPage'
import { AdminUsersPage } from '@/pages/admin/AdminUsersPage'
import { ForbiddenPage, NotFoundPage } from '@/pages/SimplePages'
import { ProfilePage } from '@/pages/ProfilePage'
import { ResidentsHome, ResidentsPage } from './ResidentsHome'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    // Public — the invitee has no session yet; the token is the credential.
    path: '/invite/accept',
    element: <AcceptInvitePage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/forbidden',
    element: <ForbiddenPage />,
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <ResidentsHome />
      </RequireAuth>
    ),
  },
  {
    path: '/residents',
    element: (
      <RequireAuth>
        <ResidentsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/profile',
    element: (
      <RequireAuth>
        <ProfilePage />
      </RequireAuth>
    ),
  },
  {
    path: '/dashboard',
    element: <Navigate to="/facilities" replace />,
  },
  {
    path: '/team',
    element: <Navigate to="/facilities" replace />,
  },
  {
    path: '/facilities',
    element: (
      <RequireAuth roles={['SUPER_ADMIN']}>
        <FacilitiesPage />
      </RequireAuth>
    ),
  },
  {
    path: '/admin',
    element: <Navigate to="/admin/organizations" replace />,
  },
  {
    path: '/admin/clients',
    element: <Navigate to="/admin/organizations" replace />,
  },
  {
    path: '/admin/organizations',
    element: (
      <RequireAuth roles={['THINKADMIN']}>
        <AdminOrganizationsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/admin/facilities',
    element: (
      <RequireAuth roles={['THINKADMIN']}>
        <AdminFacilitiesPage />
      </RequireAuth>
    ),
  },
  {
    path: '/admin/users',
    element: (
      <RequireAuth roles={['THINKADMIN']}>
        <AdminUsersPage />
      </RequireAuth>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
])
